<template>
  <AppAuthWall @complete="close" />
</template>

<script setup>
import AppAuthWall from '@/components/AppAuthWall'
const emit = defineEmits(['close'])

const close = () => {
  emit('close')
}
</script>
